import React from "react";
import style from "../application-status.scss";
import { Badge, Icon } from "@wisr/react-ui";
import { OutcomeType, StatusType } from "../../../your-applications.consts";
import { getBadgeStyle, getStatusIcon } from "../application-status.utils";

interface Props {
  status?: StatusType;
  message?: string;
  outcome?: OutcomeType;
}

export const StatusItem: React.FC<Props> = ({ status, message, outcome }) => {
  return (
    <div className={`status-item ${status}`}>
      <style jsx>{style}</style>
      {status ? (
        <>
          <div className="icon">
            <Icon name={getStatusIcon(status)} size="sm" />
          </div>
          <p>{message}</p>
        </>
      ) : outcome ? (
        <Badge type="secondary" style={getBadgeStyle(outcome)}>
          {outcome}
        </Badge>
      ) : null}
    </div>
  );
};
